import getAccountSchemaFields from "./getAccountSchemaFields";

// Allowed fields for account updates, based on backend API implementation
// See https://github.com/Aktos-Inc/aktosbackend/blob/4fdb6e/aktosbackend/core/serializers/data_import.py#L1380-L1461
const updateAbleFieldKeys = new Set([
  "special_comment_code",
  "compliance_condition_code",
  "credit_reporting_status",
  "credit_bureau_number",
  "is_skip_credit_reporting",
  "credit_bureau_notes",
  "client_reference_id",
  "original_creditor_name",
  "current_creditor_name",
  "date_of_service",
  "itemization_date",
  "date_of_first_delinquency",
  "turnover_date",
  "open_date",
  "charge_off_date",
  "interest_start_date",
  "interest_rate",
  "interest_end_date",
  "is_communication_sequence_enabled",
  "is_delete_from_credit_report",
  "is_settled",
  "is_closed",
  "cbr_class_code",
  "external_score",
]);

export default function getAccountUpdateSchemaFields(accountType) {
  const baseFields = getAccountSchemaFields(accountType, []);

  // Add account_id field as required for updates
  const accountIdField = {
    key: "account_id",
    label: "External Account ID",
    type: "string",
    validators: [{ validate: "required" }],
  };

  const updateAbleFields = baseFields
    .filter((field) => updateAbleFieldKeys.has(field.key))
    .map((field) => ({
      ...field,
      validators: [], // Set validators to an empty array for update-able fields
    }));

  return [accountIdField, ...updateAbleFields];
}
